import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Carousel,
  Button,
  Accordion,
  Modal,
  Form,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./package.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBolt,
  faTv,
  faUtensils,
  faThermometer,
  faTint,
  faPlug,
  faCartShopping,
  faChevronCircleLeft,
  faChevronCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import { currencySymbols } from "../utils/currency"; // Adjust path if needed
import ContractPDF from "./ContractPDF"; // Adjust path if needed
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { app } from "../firebaseConfig"; // Adjust path to your Firebase config

function Package() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("batteryAndSolar");
  const [exchangeRates, setExchangeRates] = useState({});
  const [country, setCountry] = useState("");
  const [showContract, setShowContract] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);

  useEffect(() => {
    fetchGeolocationAndRates();
  }, []);

  const fetchGeolocationAndRates = async () => {
    try {
      const ipapiResponse = await fetch("https://ipapi.co/json/");
      if (!ipapiResponse.ok) {
        throw new Error("Failed to fetch geolocation data");
      }
      const ipapiData = await ipapiResponse.json();
      const currencyCode = ipapiData.currency;
      setCountry(currencyCode);
      const ratesResponse = await fetch(
        `https://api.exchangerate-api.com/v4/latest/${currencyCode}`
      );
      if (!ratesResponse.ok) {
        throw new Error("Failed to fetch exchange rates");
      }
      const ratesData = await ratesResponse.json();
      setExchangeRates(ratesData.rates);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const convertPrice = (price, currency) => {
    if (exchangeRates[currency]) {
      return (parseFloat(price) * exchangeRates[currency]).toFixed(2);
    } else {
      return price;
    }
  };

  const handleSelectPackage = (pkg) => {
    // setSelectedPackage(pkg);
    // setShowContract(true);
     navigate("/Registration");
  };

  const handleAcceptContract = async () => {
    if (!clientName || !clientEmail) {
      alert("Please provide your name and email.");
      return;
    }

    const effectiveDate = new Date().toLocaleString('en-UK', { 
      month: 'numeric', 
      day: 'numeric', 
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }).replace(',', '');

    const nextPaymentDate = new Date();
    nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1);
    const nextDateStr = nextPaymentDate.toLocaleDateString('en-UK', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });

    const contractData = {
      clientName,
      packageTitle: selectedPackage.title,
      monthlyPrice: selectedPackage.title === "Our Services" ? "Variable" : convertPrice(selectedPackage.price, country),
      currencySymbol: currencySymbols[country] || country,
      effectiveDate,
      nextPaymentDate: nextDateStr,
    };

    try {
      // Generate PDF blob (assuming ContractPDF handles its own rendering)
      // const pdfBlob = await generatePdfBlob(<ContractPDF {...contractData} />);

      // // Upload to Firebase Storage
      // const storage = getStorage(app);
      // const storageRef = ref(storage, `contracts/${clientName}_${selectedPackage.title.replace(/\s+/g, '_')}.pdf`);
      // await uploadBytes(storageRef, pdfBlob);
      // const pdfUrl = await getDownloadURL(storageRef);
      // console.log('PDF URL for email:', pdfUrl);

      setShowContract(false);
      navigate("/Registration", { state: { selectedPackage, clientName, clientEmail, contractData } });
    } catch (error) {
      console.error("PDF generation error:", error);
      alert("Error generating contract. Please try again.");
    }
  };

  const handleDeclineContract = () => {
    setShowContract(false);
    setSelectedPackage(null);
    setClientName("");
    setClientEmail("");
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? packages[selectedType].length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === packages[selectedType].length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleTalkToUs = () => {
    const contactSection = document.getElementById("contact-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const packages = {
    batteryAndSolar: [
      {
        title: "Flash Plus",
        description:
          "Get your store up and running with ease. A user-friendly interface, perfectly designed for small to medium-sised businesses. Start selling today with a store that’s as intuitive as it is powerful.",
        price: "200",
        subtitle: "Upload up to 10 items",
        hours: "Complimentary custom domain | Free premium hosting",
        componets: [
          "Simple, no-fuss setup—perfect for beginners",
          "Start selling without the need for reviews",
          "Upload your items and begin trading today",
        ],
        appliances: [
          "No reviews required for simplicity",
          "Ready-to-launch ecommerce store",
          "Your store name prominently displayed",
        ],
      },
      {
        title: "Spark",
        description:
          "Ignite your business with a store that's both elegant and efficient. A clean design, combined with powerful search functionality, makes shopping a breeze for your customers.",
        price: "350",
        subtitle: "Showcase up to 30 items",
        hours: "Complimentary custom domain | Free premium hosting",
        componets: [
          "20 reviews per product to boost customer confidence",
          "Elegant, easy-to-navigate store layout",
          "Start selling immediately with an intuitive setup",
        ],
        appliances: [
          "20 product reviews to enhance buyer trust",
          "A professionally designed ecommerce store",
          "Your logo displayed proudly to represent your brand",
        ],
      },
      {
        title: "Glow",
        description:
          "Shine bright with a store that offers unlimited potential. With a sleek interface and unlimited product listings, your store will be the go-to destination for your customers.",
        price: "500",
        subtitle: "Unlimited product listings",
        hours: "Complimentary custom domain | Free premium hosting",
        componets: [
          "Unlimited reviews to showcase customer satisfaction",
          "Beautiful, user-friendly store design",
          "Built-in shopping cart for a seamless buying experience",
        ],
        appliances: [
          "Unlimited product reviews to build your brand's reputation",
          "A ready-made ecommerce store, polished to perfection",
          "Your store name prominently featured for instant recognition",
        ],
      },
      {
        title: "Our Services",
        description:
          "Elevate your business with our comprehensive suite of custom solutions. From tailored e-commerce stores to advanced analytics, we provide everything you need to succeed in the digital world, crafted to your unique vision.",
        price: "1000",
        subtitle: "Custom solutions for your business",
        hours: "Complimentary consultation | Tailored development",
        componets: [
          "E-commerce Store: Fully customised online store with advanced features",
          "App Development: Native Android & iOS apps for seamless mobile experiences",
          "Web Development: Responsive, high-performance websites",
          "Data and Analytics: Actionable insights with advanced reporting tools",
          "Software Development: Bespoke software solutions for your business needs",
          "Custom API Integrations: Seamless connectivity with third-party platforms",
        ],
        appliances: [
          "Dedicated project manager for personalised support",
          "Scalable solutions to grow with your business",
          "End-to-end development and ongoing maintenance",
        ],
      },
    ],
  };

  const progressValues = [25, 50, 75, 100];

  return (
    <Container id="package-section">
      <header className="text-center my-5">
        <h1>What We Do</h1>
        <p className="lead">Choose the best package that suits your needs</p>
      </header>

      {/* Mobile Carousel */}
      <div className="d-block d-md-none package-carousel">
        {/* Add standalone "Our Services" package above the carousel */}
        {packages[selectedType].map((pkg, index) => {
          if (pkg.title === "Our Services") {
            return (
              <div key={index} className="standalone-service mb-4">
                {/* <h2 className="text-center">Our Services</h2> */}
                <Card bg="dark" text="white" className="highlight-card">
                  <div className="progress-circle-container">
                    <svg className="progress-circle" viewBox="0 0 36 36">
                      <path
                        className="circle-bg"
                        d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                      />
                      <path
                        className="circle"
                        strokeDasharray={`${progressValues[index]}, 100`}
                        d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                      />
                    </svg>
                    <div className="icon-circle">
                      <FontAwesomeIcon icon={faCartShopping} />
                    </div>
                  </div>
                  <Card.Body>
                    <h1>{pkg.title}</h1>
                    <Card.Text>{pkg.subtitle}</Card.Text>
                    <div className="backup-hours text-center">
                      <h2>{pkg.hours}</h2>
                    </div>
                    <br />
                    <Card.Text style={{ height: "120px" }}>{pkg.description}</Card.Text>
                    <hr />
                    <div className="text-center">
                      <button
                        className="btn btn-info text-white fs-5 rounded-pill mr-2"
                        onClick={handleTalkToUs}
                      >
                        Talk to us
                      </button>
                    </div>
                    <hr />
                    <Accordion>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="bg-dark text-white">
                          What you get
                        </Accordion.Header>
                        <Accordion.Body className="bg-dark text-white">
                          <ul className="appliance-list">
                            {pkg.appliances.map((appliance, idx) => (
                              <li key={idx}>
                                <span className="appliance-txt">{appliance}</span>
                              </li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <hr />
                    <h3>What we offer</h3>
                    {pkg.componets.map((components, idx) => (
                      <li key={idx}>
                        <span>{components}</span>
                      </li>
                    ))}
                  </Card.Body>
                </Card>
              </div>
            );
          }
          return null;
        })}
        <Carousel ref={carouselRef} activeIndex={currentIndex} onSelect={setCurrentIndex} interval={300000} controls={false}>
          {packages[selectedType].filter(pkg => pkg.title !== "Our Services").map((pkg, index) => (
            <Carousel.Item key={index}>
              <Card bg="dark" text="white" className="mb-4">
                <div className="progress-circle-container">
                  <svg className="progress-circle" viewBox="0 0 36 36">
                    <path
                      className="circle-bg"
                      d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path
                      className="circle"
                      strokeDasharray={`${progressValues[index]}, 100`}
                      d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                  </svg>
                  <div className="icon-circle">
                    <FontAwesomeIcon icon={faCartShopping} />
                  </div>
                </div>
                <Card.Body>
                  <h1>{pkg.title}</h1>
                  <Card.Text>{pkg.subtitle}</Card.Text>
                  <div className="backup-hours text-center">
                    <h2>{pkg.hours}</h2>
                  </div>
                  <br />
                  <Card.Text style={{ height: "120px" }}>{pkg.description}</Card.Text>
                  <hr />
                  <Card.Text>
                    <strong className="text-uppercase">Amount </strong>
                    <br />
                    <h2 className="price-color">
                      {Object.keys(exchangeRates)
                        .filter((currency) => currency === country)
                        .map((currency) => (
                          <div key={currency}>
                            {currencySymbols[currency]
                              ? currencySymbols[currency]
                              : currency}{" "}
                            {convertPrice(pkg.price, currency)} p/m
                          </div>
                        ))}
                    </h2>
                  </Card.Text>
                  <hr />
                  <div className="text-center">
                    <button
                      className="btn btn-primary rounded-pill mr-2"
                      onClick={() => handleSelectPackage(pkg)}
                    >
                      Get package
                    </button>
                  </div>
                  <hr />
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header className="bg-dark text-white">
                        What you get
                      </Accordion.Header>
                      <Accordion.Body className="bg-dark text-white">
                        <ul className="appliance-list">
                          {pkg.appliances.map((appliance, idx) => (
                            <li key={idx}>
                              <span className="appliance-txt">{appliance}</span>
                            </li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <hr />
                  <h3>Store components</h3>
                  {pkg.componets.map((components, idx) => (
                    <li key={idx}>
                      <span>{components}</span>
                    </li>
                  ))}
                </Card.Body>
              </Card>
            </Carousel.Item>
          ))}
          <div className="carousel-controls">
            <button className="carousel-ctrl-prev" onClick={handlePrevious}>
              <FontAwesomeIcon icon={faChevronCircleLeft} size="2x"/>
            </button>
            <button className="carousel-ctrl-next" onClick={handleNext}>
              <FontAwesomeIcon icon={faChevronCircleRight} size="2x" />
            </button>
          </div>
        </Carousel>
      </div>

      {/* Desktop Grid */}
      <div className="d-none d-md-block">
        <Row>
          {packages[selectedType].map((pkg, index) => (
            <Col key={index} xs={12} sm={6} md={3} className="mb-4">
              <Card bg="dark" text="white" className={` ${pkg.title === "Our Services" ? "highlight-card" : ""}`}>
                <div className="progress-circle-container">
                  <svg className="progress-circle" viewBox="0 0 36 36">
                    <path
                      className="circle-bg"
                      d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path
                      className="circle"
                      strokeDasharray={`${progressValues[index]}, 100`}
                      d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                  </svg>
                  <div className="icon-circle">
                    <FontAwesomeIcon icon={faCartShopping} />
                  </div>
                </div>
                <Card.Body>
                  <h1>{pkg.title}</h1>
                  <Card.Text>{pkg.subtitle}</Card.Text>
                  <div className="backup-hours text-center">
                    <h4>{pkg.hours}</h4>
                  </div>
                  <br />
                  <Card.Text>{pkg.description}</Card.Text>
                  <hr />
                  {pkg.title !== "Our Services" && (
                    <Card.Text>
                      <strong className="text-uppercase">Amount</strong>{" "}
                      <br />
                      <h2 className="price-color">
                        {Object.keys(exchangeRates)
                          .filter((currency) => currency === country)
                          .map((currency) => (
                            <div key={currency}>
                              {currencySymbols[currency]
                                ? currencySymbols[currency]
                                : currency}{" "}
                              {convertPrice(pkg.price, currency)} p/m
                            </div>
                          ))}
                      </h2>
                    </Card.Text>
                  )}
                  <hr />
                  <div className="text-center">
                    <button
                      className={`btn ${pkg.title === "Our Services" ? "btn-info text-white fs-5" : "btn-primary"} rounded-pill w-100 mr-2`}
                      onClick={() =>
                        pkg.title === "Our Services" ? handleTalkToUs() : handleSelectPackage(pkg)
                      }
                    >
                      {pkg.title === "Our Services" ? "Talk to us" : "Get package"}
                    </button>
                  </div>
                  <hr />
                  <Accordion bg="dark" text="white">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header className="bg-dark text-white">
                        <strong>What you get</strong>
                      </Accordion.Header>
                      <Accordion.Body className="bg-dark text-white">
                        <ul className="appliance-list">
                          {pkg.appliances.map((appliance, idx) => (
                            <li key={idx}>
                              <span className="appliance-txt">{appliance}</span>
                            </li>
                          ))}
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <hr />
                  <h3>{pkg.title === "Our Services" ? "What we offer" : "Store components"}</h3>
                  {pkg.componets.map((components, idx) => (
                    <li key={idx}>
                      <span>{components}</span>
                    </li>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Contract Modal */}
      <Modal show={showContract} onHide={handleDeclineContract} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>EcomElevate Service Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Package:</strong> {selectedPackage?.title}</p>
          <p><strong>Price:</strong> {selectedPackage?.title === "Our Services" ? "Variable" : `${currencySymbols[country] || country} ${convertPrice(selectedPackage?.price, country)} per month`}</p>
          <p><strong>Date:</strong> {new Date().toLocaleString('en-UK', { 
            month: 'numeric', 
            day: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          }).replace(',', '')}</p>
          <p><strong>Next Payment Date:</strong> {new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleString('en-UK', { 
            month: 'numeric', 
            day: 'numeric', 
            year: 'numeric',
            hour12: true
          }).replace(',', '')}</p>
          
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
                placeholder="Enter your full name"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                value={clientEmail}
                onChange={(e) => setClientEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </Form.Group>
          </Form>
          <h5>Contract Preview:</h5>
          <PDFViewer width="100%" height={400} key={`${clientName}-${Date.now()}`}>
            <ContractPDF
              clientName={clientName || 'Your Name'}
              packageTitle={selectedPackage?.title || 'Our Services'}
              monthlyPrice={selectedPackage?.title === "Our Services" ? "Variable" : convertPrice(selectedPackage?.price, country) || '350'}
              currencySymbol={currencySymbols[country] || country}
              effectiveDate={new Date().toLocaleDateString('en-UK', { 
                day: '2-digit', 
                month: 'long',
                year: 'numeric' 
              })}
              nextPaymentDate={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('en-UK', { 
                day: '2-digit', 
                month: 'long',
                year: 'numeric' 
              })}
              componets={selectedPackage?.componets || []}
            />
          </PDFViewer>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeclineContract}>
            Decline
          </Button>
          <Button variant="primary" onClick={handleAcceptContract}>
            Accept & Proceed to Payment
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Package;